module.exports = __webpack_public_path__ + "6ab3d7d2d84787ead937c6b17d6c26b6.MP3";